<script setup lang="ts">
import { useStorage, useToggle } from "@vueuse/core";
import { themeList } from "./infoConfig";
import { IonPopover, IonContent, popoverController } from "@ionic/vue";

const [themeVis, changeThemeVis] = useToggle();

const currentTheme = useStorage("ai-theme", "brown", localStorage);

async function changeTheme(theme: string) {
  currentTheme.value = theme;
  await popoverController.dismiss();
}
</script>
<template>
  <div class="theme-tag">
    <div
      id="trigger-button"
      class="flex-column align-center justify-center"
      @click="changeThemeVis"
    >
      <i class="iconfont icon-zhuti right-bar_icon"></i>
      <span class="operate-text">主题</span>
    </div>
    <ion-popover
      :is-open="themeVis"
      :arrow="false"
      :show-backdrop="false"
      trigger="trigger-button"
      trigger-action="click"
    >
      <div>
        <div class="theme-tag_pop">
          <div
            v-for="item in themeList"
            :key="item.value"
            class="theme-pop-item"
            @click="changeTheme(item.value)"
          >
            <div
              class="theme-pop-item_icon"
              :class="[item.class, currentTheme === item.value ? item.activeClass : '']"
            ></div>
            <!--            <div class="theme-pop-item_title">{{item.label}}</div>-->
          </div>
        </div>
      </div>
    </ion-popover>
  </div>
</template>
<style scoped lang="less">
@import "@/assets/common.less";

.operate-text {
  font-size: var(--font-pure-2);
  white-space: nowrap;
  color: var(--icon-color, #262626);
}

.right-bar_icon {
  font-size: 20px;
  color: var(--icon-color, #262626);
}

.theme-tag {
  &_pop {
    padding: 2vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .theme-pop-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 1vw;
      &_icon {
        width: 5vw;
        height: 5vw;
        border-radius: 50%;
      }
      &_title {
        color: var(--font-black-color);
        font-size: var(--font-pure-2);
      }
      .default-class {
        background: linear-gradient(180deg, #f8f8f8 0%, #e9e7e7 77.5%);
        &-active {
          border: 2px solid #2bca9c;
        }
      }
      .brown-class {
        background: linear-gradient(180deg, #fcefda 0%, #f9dfb5 77.5%);
        &-active {
          border: 2px solid #b35f34;
        }
      }
      .silver-class {
        background: linear-gradient(180deg, #eff3fc 0%, #007aff 77.5%);
        &-active {
          border: 2px solid #007aff;
        }
      }
      .dark-class {
        background: linear-gradient(180deg, #292a2a 0%, #000201 77.5%);
        &-active {
          border: 2px solid #c0995d;
        }
      }
    }
  }
}
</style>
